import { useNavigate } from 'react-router-dom'
import './styles.scss'

const NotFound = () => {
  const navigate = useNavigate()

  return (
    <div className="not-found">
      <div className="not-found__content">
        <span className="not-found__code">404</span>
        <h1 className="not-found__title">Page Not Found</h1>
        <p className="not-found__desc">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="not-found__actions">
          <button className="not-found__btn not-found__btn--primary" onClick={() => navigate('/')}>
            Back to Home
          </button>
          <button className="not-found__btn not-found__btn--ghost" onClick={() => navigate(-1)}>
            Go Back
          </button>
        </div>
      </div>
    </div>
  )
}

export default NotFound
